var cartUpdateCalledFromFree = false;
var USE_NATIVE_BXGY_ONLY = true;

var sku;
var gcallback;
var to_add = 0;

handle_BOGO = function (cart,callback) {
  if (USE_NATIVE_BXGY_ONLY) {
    return false;
  }

  gcallback = callback;
  returnvalue = false;

  console.log('handle_BOGO', ctags, cart);

  var inGroup = false;
  if (typeof ctags !== 'undefined' && ctags.toUpperCase().split(',').indexOf('GROUP:HPROF') > -1)
    inGroup = true;
  //var buyone_variantid = '30144169803842';
  var buyx = 12;
  var gety = 1;
  //if (buyone_variantid.trim().length == 0)
  //  return false;
  //buyone_variantid = parseInt(buyone_variantid);
  var variantObjects = [];
  //variantObjects.push({'id':'30144169803842','handle':'herbatoninpro-03mg'});
  $(cart.items).each(function(){
    if (!isFree(this))
      variantObjects.push({'id':this.variant_id.toString(),'handle':''});
  });

  if (!variantObjects.length)
  {
    let reload = false;
    $(cart.items).each(function(i){
      if (isFree(this))
        reload = true;
        youCanDoItQueueREMOVE(i + 1,0);
      });
    return reload;
  }

        $.each(variantObjects,function(i,skuset) {  //this was going to be able to handle more than one but not needed..ignore queue talk
            if (skuset['id'].trim().length == 0)
              return;
            sku = parseInt(skuset['id']);
            console.log(sku);
            var bought_cart_id = cart.items.findIndex(function(x){return (x.id===sku && !isFree(x))});
            var free_cart_id = cart.items.findIndex(function(x){return (x.id===sku && isFree(x))});
            var bought_count = bought_cart_id > -1 ? cart.items[bought_cart_id].quantity : 0;
            var free_count = free_cart_id > -1 ? cart.items[free_cart_id].quantity : 0;

            if (!inGroup) {
              if (free_count > 0)
              {
                youCanDoItQueueREMOVE(free_cart_id + 1,0);
                returnvalue = true;
              }
              //else
              //  return false;
            }
            else {
              if (bought_count >= buyx || free_count > 0)
              {
                  var supposed_to_get = Math.floor(bought_count/buyx);
                  if (free_count > supposed_to_get) {
                    youCanDoItQueueREMOVE(free_cart_id + 1,supposed_to_get);
                    returnvalue = true;
                  } else if (free_count < supposed_to_get){
                    if (free_count > 0)
                      to_add = supposed_to_get - cart.items[free_cart_id].quantity;
                    else
                      to_add = supposed_to_get;
                    returnvalue = true;
                    /*$.ajax({
                      type: "GET",
                      url: "/products/" + skuset['handle'] + ".js",
                      dataType: "json",
                      success: function(response) {
                        var variants = response.variants;
                        var available = variants[0].available; //since this gwp is happening on every product just assume theres inventory for now
                            if (available)*/
                              youCanDoItQueueADD(sku,to_add);
                            /*else
                              ShopifyAPI.getCart(gcallback);
                        }
                      });*/
                  }
               }
            }
      });
      return returnvalue;
};

  youCanDoItQueueREMOVE = function (lineNumber,qty) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: qty, line: lineNumber },
      success: function (data) {
        ShopifyAPI.getCart(gcallback);
      },
      error: function (XMLHttpRequest, textStatus) {
        ShopifyAPI.getCart(gcallback);  //cannot update empty cart
      }
    });
  };

  youCanDoItQueueADD = function (sku,qty) {
    $.ajax({
      type: 'POST',
      data: { quantity: qty, id: sku,
        properties: { 'Gift': 'Free' }
      },
      url: '/cart/add.js',
      dataType: 'json',
      success: function(item) {
        ShopifyAPI.getCart(gcallback);
      },
      error: function (XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    });
  };

  isFree = function (lineitem) {
    var free = false;
    $.each(lineitem.properties,function(i,prop){
      if (prop == 'Free') //should match on property name not just value
        free = true;
    });
    return free;
  };

  var reload = false;

  function tryBOGO() {
    $.getJSON('/cart.js', function (cart) {
          reload = handle_BOGO(cart,done);
    });
  }

  function tryBOGOWithLiquidCart() {
    if (typeof gwp_cart !== 'undefined')
          reload = handle_BOGO(gwp_cart,done);
  }

  function done() {
    if (reload)
      window.location.reload();
  }
